import React, {useEffect, useState} from 'react';

export const useTags = (samples, stream) => {
    
    let [tags, setTags] = useState({});
    let [groupBy, setGroupBy] = useState(undefined);

    useEffect(() => {
        if (groupBy !== "TAGS" && stream && stream._tagSounds) {
            stream.tagSounds = undefined;
        }
    }, [groupBy, stream]);

    useEffect(() => {
        if (groupBy !== "TAGS") {
            return;
        }
        let _tags = {};
        for (let sample of samples) {
            for (let tag of sample.tags) {
                if (! (tag in _tags)) {
                    _tags[tag] = [];
                }
                _tags[tag].push(sample);
            }
        }
        setTags(_tags);
    }, [samples, groupBy]);

    return {tags, groupBy, setGroupBy};
};
